<template>
    <div>
        <div v-if="show" class="phone-alert" v-ripple @click="showEditPersonalInfo">
            <span class="phone-alert__icon">
                <v-icon size="18" color="accent">mdi-phone-alert-outline</v-icon>
            </span>
            <span class="phone-alert__text">{{ $t('common.config_your_phone') }}</span>
            <button type="button" class="phone-alert__close" @click.stop="closeAlert">
                <v-icon size="14">mdi-close</v-icon>
            </button>
        </div>

        <edit-personal-info-dialog ref="personalInfo" />
    </div>
</template>

<script>
import EditPersonalInfoDialog from '@/components/common/EditPersonalInfoDialog'

export default {
    name: "NoPhoneSet",
    components: { EditPersonalInfoDialog },
    data() {
        return {
            dismissed: false,
        }
    },
    computed: {
        show(vm = this) {
            if (vm.dismissed) return false
            return !vm.account?.phone && (!localStorage.builder_noShowRequiredPhoneAgain || localStorage.builder_noShowRequiredPhoneAgain === 'false')
        },
    },
    methods: {
        showEditPersonalInfo() {
            this.$refs.personalInfo.show()
        },
        closeAlert() {
            localStorage.builder_noShowRequiredPhoneAgain = true
            this.dismissed = true
        },
    }
}
</script>

<style scoped>
.phone-alert {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    margin-bottom: 12px;
    border-radius: 12px;
    border: 1px solid rgba(51, 153, 153, .35);
    background: rgba(51, 153, 153, .08);
    cursor: pointer;
    transition: background .15s;
}

.phone-alert:hover {
    background: rgba(51, 153, 153, .14);
}

.phone-alert__icon {
    flex-shrink: 0;
    display: flex;
}

.phone-alert__text {
    flex: 1;
    min-width: 0;
    font-size: var(--fs-body);
    color: var(--v-txtPrimary-base);
    line-height: 1.4;
}

.phone-alert__close {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid var(--v-outline2-base);
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--v-txtSecondary-base);
    cursor: pointer;
    transition: border-color .15s, color .15s;
}

.phone-alert__close:hover {
    border-color: var(--v-txtSecondary-base);
    color: var(--v-txtPrimary-base);
}
</style>
